/**
 * CalendarEmulator Class
 * Used to emulate functionality of the native PickADate class.
 * This version is specifically tuned for Zapiet's integration.
 */
const calendar_api_url = "https://sugarees-prod-289d7ab08505.herokuapp.com";
let sug_global_selected_date = null;


class CalendarEmulator {
    /** Creates A New CalendarEmulator Object From A DOM Element And Init Observer.
     * @param element The Calendar's DOM element.
     */
    constructor(element) {

        var missingDaysString = $('#missing-weekdays').data('missing-days');

        this.main = element;
        this.dom = element;
        this.observer = new MutationObserver(this.processChanges);
        this.selectedDate = $(this.dom).find('.Zapiet-Calendar__Date--selected.picker__day')[0] == null ? null : $(this.dom).find('.Zapiet-Calendar__Date--selected.picker__day')[0].attr('aria-label');
        this.disabledDaysOfWeek = missingDaysString.length > 0 ? missingDaysString.split(', ') : []; // Sun, Mon, Tue, Wed, Thu, Fri, Sat
        this.disabledDates = []; // 00 Month, 2XXX
        this.disabledClass = 'Zapiet-Calendar__Date--disabled picker__day--disabled';
        this.monthElement = $(this.main).find('.Zapiet-Calendar__Month')[0];
        this.selectedMonth = $(this.monthElement).find('div')[0].innerText;
        this.global_zip_rates = {};
        this.selectedZip = null;
        this.lastQuantity = 0;

        this.disableHardDisabledDates();

        this.updateSumQuantity();


        // Run initialization.
        this.initialize();
    }

    /**
     *  Runs the moment the class is initialized. 
     */
    initialize = () => {
        this.disableHardDisabledDates();
        this.refreshCalendar();

        $('#checkout__scheduled-shipping').on('click', function(event) {
            this.addOrderInformation();
        });

        $('#storePickupApp').show();
    }

    /** Define Event Handling Method
     * Params are passed by observer object.
     * @param changes An array of changes that were detected.
     * @param observer The observer object.
     */
    processChanges = (changes, observer) => {
        console.log("Something has changed!");
        const changedSelection = this.updateSelectedDate();
        const changedMonth = this.updateSelectedMonth();

        if (changedMonth) {
            this.refreshCalendar();
        }

        if (changedSelection) {
            console.log("Changed: " + this.selectedDate);
            sug_global_selected_date = this.selectedDate;
            var self = this; // Fixes issue with scoping.

            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cart_json = cart;
                cart_token = cart_json['token'];
                console.log(typeof cart_json);
                $.ajax({
                    type: 'POST',
                    crossDomain: true,
                    data: JSON.stringify({ 'token': cart_token, 'date': this.selectedDate, 'order_number': '0'}),
                    contentType: 'application/json',
                    url: calendar_api_url + "/webhooks/post-arrival-date",
                    success: function (response) {
                        console.log(response);
                        self.enableCheckout();
                    }
                });
            })
        }
    }

    /**
     * Adds Information To Product.
     */
    addOrderInformation = () => {

    }

    /**
     * Get current sum of quantity.
     */
    updateSumQuantity = () => {
        // Reset the lastQuantity to 0 before summing again
        this.lastQuantity = 0;

        $('.QuantitySelector__CurrentQuantity').each((index, element) => {
            // Get the value of the input field and convert it to a number
            let quantity = parseFloat($(element).val()) || 0;

            // Add the quantity to lastQuantity
            this.lastQuantity += quantity;
        });
    }


    /**
     * Updates the selected date.
     * @return changed If the selected date has changed.
     */
    updateSelectedDate = () => {
        console.log("Changed?");
        const newDate = $(this.dom).find('.Zapiet-Calendar__Date--selected.picker__day')[0] == null ? null : $(this.dom).find('.Zapiet-Calendar__Date--selected.picker__day').attr('aria-label');
        const changed = (newDate !== this.selectedDate);
        this.selectedDate = newDate;
        console.warn(newDate);

        return changed;
    }

    /**
     * Updates the selected data.
     * @return changed If the selected date has changed.
     */
    updateSelectedMonth = () => {
        const newMonth = $(this.monthElement).find('div')[0].innerText;
        const changed = (newMonth !== this.selectedMonth);
        this.selectedMonth = newMonth;

        return changed;
    }

    /**
     * Disable and unselects all dates on the calendar.
     * @param removeSelection Should the current selection be removed
     */
    disableAllDates = (removeSelection) => {
        let changes = $(this.dom)
            .find('.picker__day')
            .addClass(this.disabledClass)

        if (removeSelection) {
            changes.removeClass('picker__day--selected picker__day--highlighted');
        }
    }

    /**
     * Sets disabled dates and refreshes the calendar
     * @param disabledDates Array of dates (XX Month, 2XXXX)
     */
    setDisabledDates = (disabledDates) => {
        this.disabledDates = disabledDates;
        this.refreshCalendar();
    }

    /**
     * Disables A Date
     * @param date A Date to be disabled.
     */
    disableDate = (date) => {
        $(this.main)
            .find("[aria-label*='" + date + "']")
            .addClass(this.disabledClass)
            .removeClass('picker__day--selected picker__day--highlighted')
            .addClass('picker__day-temp-disabled');
    }

    /**
     * Adds Prices to Elements from an array of dates.
     * @param prices Array of prices and dates.
     */
    addPricesToElements = (prices) => {
        Object.keys(prices).forEach(key => {
            if (prices[key] == '0') {
                this.disableDate(key);
            } else {
                // Only apply if shipping. Still allows for disabling holidays.
                if ($('#zapiet-widget-container').hasClass('shipping-cal')) {
                    this.addAttributesToDates([key], 'data-rate-cost', '$' + prices[key])
                }
            };            
        });
    }

    /**
     * Parsers to Correct Date Format
     * @param date Date String to Parse
     * @return formattedDate Date String in proper format
     */
    toCorrectDateFormat = (date) => {
        const dateObject = new Date(date);
        const formattedDate = new Intl.DateTimeFormat('en-US', { 
            month: 'long', 
            day: 'numeric', 
            year: 'numeric' 
        }).format(dateObject);

        return formattedDate;
    }

    /**
     * Converts back to Zapiet Calendar Format.
     * @param date Date String to Parse
     * @return formattedDate Date String in Zapiet Calendar Format
     */
    toZapietCalendarFormat = (date) => {
        const dateStr = new Date(date);

        // Extract individual components
        const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(dateStr);
        const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(dateStr);
        const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(dateStr);
        const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(dateStr);
    
        // Combine the components into the desired format
        const formattedDate = `${weekday}, ${day} ${month}, ${year}`;
        console.log(formattedDate);
    
        return formattedDate;
    }

    // Refreshes calendar to a default slate...
    cleanCalendarSlate = () => {
            // Enable All.
            $(this.dom)
                .find(".picker__day")
                .removeClass(this.disabledClass);

            // Disable all that are less than 2 days away.
            let calendar_dates = $(this.dom).find(".picker__day");
            calendar_dates.forEach(function(date) {
                
            });

    }

    /**
     * Refreshes the calendar
     */
    refreshCalendar = () => {
      
        // Skip on pickup page.
        if ($(".shipping-cal").length == 0) {
            this.disableHardDisabledDates();
            $('.lds-spinner').remove();
            return false;
        }

        this.disableNavigationButtons();
        this.removeDollarValues();
        console.log("Refreshing...");

        // Check for ZIP code.
        console.log("Current ZIP: " + this.selectedZip);
        if (this.selectedZip == null) {
            // Give error message and return early.
            return false;
        }

        // Check for the originals.
        var validSelector = null;
        if ($(this.main).find('zapiet-original-date').length != 0) {
            validSelector = $(this.main).find('zapiet-original-date');
        } else {
            validSelector = $(this.main).find('.picker__day:not(.picker__day--disabled), .picker__day-temp-disabled');
            $(validSelector).addClass('zapiet-original-date');
        }

        var self = this; // Fixes issue with scoping.
        // Marking the originals.
        var validDates = $.unique(validSelector).map(function() {
            let fullLabel = $(this).attr('aria-label');
            return self.toCorrectDateFormat(fullLabel.substring(fullLabel.indexOf(",") + 2));
        }).get();
    
        this.getCalendarInformation(this.selectedZip, validDates);
        $('.lds-spinner').hide();
    }

    /**
     * Disables navigation buttos on calendar.
     */
    disableNavigationButtons() {
        console.log("DISABLING NAVIGATION!");
        console.log($(this.main).find(".Zapiet-Calendar__Nav"));
        $(this.main).find(".Zapiet-Calendar__Nav").addClass('Zapiet-Calendar__Nav--disabled')
    }

    /**
     * Enables navigation buttos on calendar.
     */
    enableNavigationButtons() {
        $(this.main).find(".Zapiet-Calendar__Nav").removeClass('Zapiet-Calendar__Nav--disabled');
    }

    /**
     * Gets Calendar Prices and Dates From External Server
     */
    getCalendarInformation = (zip = null, cal_dates = null) => {
        // Skip if null zip.
        if (zip == null) {
            return false;
        }
        this.disableAllDates();
        // Skip if in cache.
        let lastQuantity = this.lastQuantity;
        this.updateSumQuantity();
        let newQuantity = this.lastQuantity;
        if (this.global_zip_rates[zip] != null && lastQuantity == newQuantity) {
            console.log(this.global_zip_rates[zip]);
            console.log(this.global_zip_rates[zip][this.selectedMonth]);
            if (this.global_zip_rates[zip][this.selectedMonth] != null) {
                let toEnable = Object.keys(this.global_zip_rates[zip][this.selectedMonth]);
                this.enableListOfDates(toEnable);
                this.addPricesToElements(this.global_zip_rates[zip][this.selectedMonth]);
                this.enableNavigationButtons();
                return;
            }
        }
        fetch('/cart.js') 
        .then(response => response.json())
        .then(cart => {
            let cart_json = cart;
            //console.log(cart_json);
            cart_token = cart['token'];
            //console.log(typeof cart_json);
            //let cart_json = JSON.parse('{"token":"' + cart_token + '","note":null,"attributes":{"Shipping-Date":"2024\\/09\\/19","Checkout-Method":"shipping"},"original_total_price":7900,"total_price":7900,"total_discount":0,"total_weight":3175.1466,"item_count":1,"items":[{"id":42301112221896,"properties":{"Arrival Date":"March 18, 2024","_Cart_Token":"c1-c24c5ed8d36abed2d1485f061c16463c"},"quantity":1,"variant_id":42301112221896,"key":"42301112221896:96c09d772966ad26c55143709176d1ee","title":"Chocolate Cake - Schedule Shipping","price":6400,"original_price":6400,"presentment_price":64,"discounted_price":6400,"line_price":6400,"original_line_price":6400,"total_discount":0,"discounts":[],"sku":"607MO","grams":3175,"vendor":"Sugaree\'s","taxable":true,"product_id":7337177645256,"product_has_only_default_variant":false,"gift_card":false,"final_price":6400,"final_line_price":6400,"url":"\\/products\\/chocolate-buttercream-frosting-cake?variant=42301112221896","featured_image":{"aspect_ratio":1,"alt":"Chocolate cake on a tray next to a green vase with red roses","height":1000,"url":"https://cdn.shopify.com/s/files/1/0615/3391/3288/products/Sugarees-Chocolate-Buttercream-Frosting-Cake.jpg?v=1652977561","width":1000},"image":"https://cdn.shopify.com/s/files/1/0615/3391/3288/products/Sugarees-Chocolate-Buttercream-Frosting-Cake.jpg?v=1652977561","handle":"chocolate-buttercream-frosting-cake","requires_shipping":true,"product_type":"Cakes","product_title":"Chocolate Cake","product_description":"A moist chocolate cake with rich chocolate buttercream icing, you may not be able to eat anyone else’s chocolate cake again.","variant_title":"Schedule Shipping","variant_options":["Schedule Shipping"],"options_with_values":[{"name":"Availability","value":"Schedule Shipping"}],"line_level_discount_allocations":[],"line_level_total_discount":0,"has_components":false}],"requires_shipping":true,"currency":"USD","items_subtotal_price":6400,"cart_level_discount_applications":[]}');
            //delete this.global_zip_rates[zip];
            console.log(cart_token);
            $.ajax({
                type: 'POST',
                crossDomain: true,
                data: JSON.stringify({ 'zip': zip, 'data': cart_json, 'cal': cal_dates}),
                contentType: 'application/json',
                url: calendar_api_url + "/webhooks/zapiet-shipping-preview",
                success: function (response) {
                    console.log('Response...');
                    console.log(response);
                    if (response['errors'] != null) {
                        const error_holder = $('.ajax-response')
                        const error_message = $("#ajax-error-message");
                        var errors = 0;
                        var new_error_message = error_message.clone();
                        new_error_message.attr('id', error_message.attr('id') + errors);
                        new_error_message.text("Please fix the following errors and try again.");
                        new_error_message.css('display', '');
                        new_error_message.css('text-decoration', 'underline');
                        error_holder.append(new_error_message);
                        response['errors'].forEach(function(error) {
                            errors += 1;
                            var new_error_message = error_message.clone();
                            new_error_message.attr('id', error_message.attr('id') + errors);
                            new_error_message.text(error);
                            new_error_message.css('display', '');
                            error_holder.append(new_error_message);
                        });
                    }else if (response['calendar'] == true) {
                        // Add ZIP cache if doesn't exist.
                        if (this.global_zip_rates[zip] == null) {
                            this.global_zip_rates[zip] = {};
                        }
                        var convertedResponse = {};
                        var self = this; // Scoping error fix.
                        // Convert to Zapiet format.
                        Object.keys(response['prices']).forEach(function(date) {
                            convertedResponse[self.toZapietCalendarFormat(date)] = response['prices'][date];
                        });
                        this.global_zip_rates[zip][this.selectedMonth] = convertedResponse;
                        let toEnable = Object.keys(this.global_zip_rates[zip][this.selectedMonth]);
                        this.enableListOfDates(toEnable);
                        this.addPricesToElements(this.global_zip_rates[zip][this.selectedMonth]);
                        //$(".Cart__Checkout").prop('disabled', 'disabled');
                        $('#main-checkout').removeAttr('disabled');
                        $('#calculate-rates').show();
                        $('#calculate-rates').next().remove();
                        this.enableNavigationButtons();
                    } else {
                        //$(".Cart__Checkout").prop('disabled', 'disabled');
                        $('#main-checkout').removeAttr('disabled');
                        $('#calculate-rates').show();
                        $('#calculate-rates').next().remove();
                        $('#processing-message').hide();
                    }
                }.bind(this),
                error: function(xhr, status, error) {
                    console.log(error);
                    console.error('Error in AJAX call:', error);
                    $('.ajax-response').css('display', '');
                    $("#ajax-error-message").text(error);
                    //$(".Cart__Checkout").prop('disabled', 'disabled');
                    $('#main-checkout').removeAttr('disabled');
                    $('#calculate-rates').show();
                    $('#calculate-rates').next().remove();
                } 
            });
        })
        .catch(error => console.error('Error fetching cart:', error));
    }



    /**
     * Remove dollar values from all dates.
     */
    removeDollarValues = () => {
        // Remove Old Dollar Values
        $(this.dom).find(".Zapiet-Calendar__Dates button").attr("data-rate-cost", "");
    }

    /** Disables checkout. */
    disableCheckout = () => {
        //$(".Cart__Checkout").prop('disabled', true);
    }

    /** Enables checkout. */
    enableCheckout = () => {
        //$(".Cart__Checkout").prop('disabled', false);
    }

    /**
     * Ensures the correct dates are disabled.
     */
    disableHardDisabledDates = () => {
        
        // Ignore if all days are present.
        console.log(this.disabledDaysOfWeek.length);
        if (this.disabledDaysOfWeek.length < 7) {
            // Disable closed days of the week.
            this.disabledDaysOfWeek.forEach(date => {
                $(this.dom)
                    .find(".Zapiet-Calendar__Dates button[aria-label*='" + date + ",']")
                    .addClass(this.disabledClass)
                    .removeClass('picker__day--selected picker__day--highlighted');
            });
        }

        // Disable set disabled days (Usually Holidays)
        this.disabledDates.forEach(date => {
            $(this.dom)
                .find("[aria-label*='" + date + "']")
                .addClass(this.disabledClass)
                .removeClass('picker__day--selected picker__day--highlighted');
        });
    }

    /**
     * Enables an array of dates on the calendar
     * @param dates Array of dates by aria-labels
     */
    enableListOfDates = (dates) => {
        dates.forEach(date => {
            $(this.dom)
                .find("[aria-label*='" + date + "']")
                .removeClass(this.disabledClass);
        });
        this.disableHardDisabledDates();
    }

    /**
     * Adds attributes to a list of dates.
     * @param dates Array Of Dates
     * @param attribute Attribute Label
     * @param value Attribute Value
     */
    addAttributesToDates = (dates, attribute, value) => {
        dates.forEach(date => {
            $(this.dom)
                .find("[aria-label*='" + date + "']")
                .attr(attribute, value);
        });
    }

    /** 
     * Define Method To Start Observer 
     */
    beginObserving = () => {
        const observerOptions = {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        };
        this.observer.observe(this.dom, observerOptions);
    }
    
    /** Halts observer processes.
     * Can be resumed by calling beginObserving.
     */
    haltObserver = () => {
        this.observer.disconnect();
    }
}

/**
 * Starts the Calendar Emulation Process
 * @param Calendar The Calendar to Observe
 */
function initialize(Calendar) {
    console.log('Calendar Emulator Started');
    const CurrentCalendar = new CalendarEmulator(Calendar);
    CurrentCalendar.beginObserving();

    // @TODO: Confirm this is shipping calendar.
    // Checkout button handling.
    $('body').on('click', '#calculate-rates', function (e) {
        e.preventDefault();
        //$(this).hide().after(preloader_svg);
        $('#callback-message').remove();
        $('#zapiet-widget-container').show();

        CurrentCalendar.selectedZip = $('#zip-picker').val();
        CurrentCalendar.refreshCalendar();
        console.log(CurrentCalendar.selectedZip);
    });
}

function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Init Calendar
 */
async function initCalendar() {
    const calendarHolder = $('#storePickupApp');

    // Return early if the calendar should not appear on this page.
    if (!calendarHolder.length) {
        console.log("No calendar found.");
        return;
    }

    let calendarWrapper = $('.Zapiet-Calendar__Wrapper');

    console.log(calendarWrapper);
    if (calendarWrapper.length) {
        // Initialize the Calendar Observer.
        initialize(calendarWrapper[0]);
    } else {
        // Awaiting creation of Calendar Instance...
        const calendarWaiter = new MutationObserver((changes, observer) => {
            let calendarWrapper = $('.Zapiet-Calendar__Wrapper');
            if (calendarWrapper.length) {
                // Stop the observer to free resources.
                calendarWaiter.disconnect();

                // Initialize the Calendar Observer.
                initialize(calendarWrapper[0]);
            }
        });
        calendarWaiter.observe($('#storePickupApp')[0], {
            childList: true,
            subtree: true,
        });
    };
}



$(window).on('load',function() {
    setTimeout(() => {
        initCalendar();
    }, "2000");

    // Refresh page on remove.
    console.log($(".CartItem__Remove"));

    $(document).on("click", ".CartItem__Remove", function(){
        console.log("Clicked!");
        var pageref = setInterval(function(){
            location.reload();
        }, 1000);
    });
});